import React from 'react';
import { Checkbox, Empty } from 'antd';
import { Table, Column, CellMeasurerCache, CellMeasurer } from 'react-virtualized';
import cx from 'classnames';

import useCheckbox from './useCheckbox';
import { ColumnItem, ListItem } from './types';
import { CellContentStyle, HeaderStyle, VirtualizedTableWrapperStyle } from './style';

interface VirtualizedTableProps {
  width: number;
  height: number;
  list: ListItem[];
  columns: ColumnItem[];
  checkedIdList?: string[];
  setCheckedIdList?: (checkedIdList: string[]) => void;
}

const DEFAULT_CELL_HEIGHT = 46;
const cache = new CellMeasurerCache({
  fixedWidth: true,
  defaultHeight: DEFAULT_CELL_HEIGHT,
});

const VirtualizedTable = (props: VirtualizedTableProps): JSX.Element => {
  const { list, columns, width, height, checkedIdList, setCheckedIdList } = props;
  const { checkboxAllStatus, updateCheckbox, updateCheckboxAll } = useCheckbox({
    list,
    checkedIdList,
    setCheckedIdList,
  });

  return (
    <VirtualizedTableWrapperStyle minWidth={width}>
      <Table
        className={cx('virtualized-table', { empty: list.length === 0 })}
        width={width}
        height={height}
        headerHeight={DEFAULT_CELL_HEIGHT}
        rowHeight={cache.rowHeight}
        rowCount={list.length}
        rowGetter={({ index }: { index: number }) => list[index]}
        noRowsRenderer={() => <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="주문을 업로드해주세요." />}
        deferredMeasurementCache={cache}
      >
        {checkedIdList && (
          <Column
            dataKey="id"
            width={64}
            cellRenderer={(data) => (
              <CellMeasurer cache={cache} columnIndex={data.columnIndex} parent={data.parent} rowIndex={data.rowIndex}>
                <CellContentStyle>
                  <Checkbox
                    checked={checkedIdList.includes(data.rowData.id)}
                    onChange={(e) => updateCheckbox(e.target.checked, data.cellData)}
                  />
                </CellContentStyle>
              </CellMeasurer>
            )}
            headerRenderer={() => (
              <HeaderStyle>
                <Checkbox
                  indeterminate={checkboxAllStatus === 'indeterminate'}
                  checked={checkboxAllStatus === 'checked'}
                  onChange={(e) => updateCheckboxAll(e.target.checked)}
                />
              </HeaderStyle>
            )}
          />
        )}
        {columns.map((column: ColumnItem) => (
          <Column
            key={column.dataKey}
            dataKey={column.dataKey}
            label={column.label}
            width={column.width}
            cellRenderer={(data) => (
              <CellMeasurer cache={cache} columnIndex={data.columnIndex} parent={data.parent} rowIndex={data.rowIndex}>
                <CellContentStyle>
                  {columns[checkedIdList ? data.columnIndex - 1 : data.columnIndex].render(data.cellData, data.rowData)}
                </CellContentStyle>
              </CellMeasurer>
            )}
            headerRenderer={(data) => <HeaderStyle>{data.label}</HeaderStyle>}
          />
        ))}
      </Table>
    </VirtualizedTableWrapperStyle>
  );
};
export default VirtualizedTable;
